import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const BlogPost3 = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[420px] md:h-[480px] overflow-hidden">
        <img
          alt="Qué insumos de oficina no deben faltar en una empresa mediana"
          title="Qué insumos de oficina no deben faltar en una empresa mediana - CX Comercializadora Puebla"
          className="w-full h-full object-cover object-top"
          src="https://public.readdy.ai/ai/img_res/c3fe5f5621e413f5f50b17b9194b04b5.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20"></div>
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-4xl mx-auto px-6 pb-12 w-full">
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 text-white/80 hover:text-white text-sm font-medium mb-5 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-lg"></i>
              Volver al Blog
            </Link>
            <div className="flex items-center gap-3 mb-4">
              <span className="bg-[#2d5a8c] text-white px-4 py-1.5 rounded-full text-xs font-bold">Productos</span>
              <span className="text-white/80 text-sm flex items-center gap-1.5">
                <i className="ri-calendar-line"></i>
                5 Marzo 2024
              </span>
              <span className="text-white/80 text-sm flex items-center gap-1.5">
                <i className="ri-time-line"></i>
                5 min
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
              Qué insumos de oficina no deben faltar en una empresa mediana
            </h1>
          </div>
        </div>
      </section>
      
      {/* Contenido del Artículo */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid lg:grid-cols-[1fr_280px] gap-12">
            <article className="prose-article">
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                Mantener un inventario básico de insumos es fundamental para evitar interrupciones operativas.
              </p>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                A continuación, te compartimos los productos esenciales que no deben faltar.
              </p>
              
              <h3 className="text-xl md:text-2xl font-bold text-[#1e3a5f] mt-10 mb-4 leading-tight">
                <a href="#section-2" id="section-2" className="hover:text-[#2d5a8c] transition-colors">
                  Papel y consumibles de impresión
                </a>
              </h3>
              <ul className="space-y-3 mb-6 ml-1">
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Papel blanco tamaño carta 70g
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Tóner y tinta
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Protectores de hojas
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                Estos productos son indispensables para la operación administrativa diaria.
              </p>
              
              <h3 className="text-xl md:text-2xl font-bold text-[#1e3a5f] mt-10 mb-4 leading-tight">
                <a href="#section-5" id="section-5" className="hover:text-[#2d5a8c] transition-colors">
                  Organización y archivo
                </a>
              </h3>
              <ul className="space-y-3 mb-6 ml-1">
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Folders
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Carpetas panorámicas
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Recopiladores
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                Mantener documentación organizada mejora productividad.
              </p>
              
              <h3 className="text-xl md:text-2xl font-bold text-[#1e3a5f] mt-10 mb-4 leading-tight">
                <a href="#section-8" id="section-8" className="hover:text-[#2d5a8c] transition-colors">
                  Escritura y señalización
                </a>
              </h3>
              <ul className="space-y-3 mb-6 ml-1">
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Bolígrafo punto fino
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Marcador permanente
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Notas adhesivas
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                Pequeños insumos que impactan directamente en la eficiencia diaria.
              </p>
              
              <h3 className="text-xl md:text-2xl font-bold text-[#1e3a5f] mt-10 mb-4 leading-tight">
                <a href="#section-11" id="section-11" className="hover:text-[#2d5a8c] transition-colors">
                  Suministros complementarios
                </a>
              </h3>
              <ul className="space-y-3 mb-6 ml-1">
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Cinta de empaque
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Masking tape
                </li>
                <li className="flex items-start gap-3 text-gray-700 leading-relaxed text-[15px]">
                  <span className="w-2 h-2 rounded-full bg-[#2d5a8c] mt-2 flex-shrink-0"></span>
                  Artículos de limpieza
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                Una empresa organizada siempre previene faltantes.
              </p>
              <p className="text-gray-700 leading-relaxed mb-5 text-[15px]">
                En CX Comercializadora ofrecemos variedad de insumos empresariales en Puebla para cubrir todas estas necesidades.
              </p>
              
              <div className="mt-12 bg-gradient-to-br from-[#f0f5fb] to-[#e8eff8] rounded-xl p-8 border border-[#d0dff0]">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#2d5a8c] rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-2-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-[#1e3a5f] mb-2">¿Necesitas asesoría personalizada?</h4>
                    <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                      Nuestro equipo puede ayudarte a optimizar tus compras de insumos empresariales en Puebla.
                    </p>
                    <Link
                      to="/contacto"
                      className="inline-flex items-center gap-2 bg-[#2d5a8c] text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-[#1e3a5f] transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Solicitar cotización
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </article>
            
            {/* Sidebar */}
            <aside className="hidden lg:block">
              <div className="sticky top-28 space-y-8">
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                  <h4 className="text-sm font-bold text-[#1e3a5f] mb-4 uppercase tracking-wider">Contenido</h4>
                  <nav className="space-y-2.5">
                    <a href="#section-2" className="block text-sm text-gray-600 hover:text-[#2d5a8c] transition-colors cursor-pointer leading-snug">
                      Papel y consumibles de impresión
                    </a>
                    <a href="#section-5" className="block text-sm text-gray-600 hover:text-[#2d5a8c] transition-colors cursor-pointer leading-snug">
                      Organización y archivo
                    </a>
                    <a href="#section-8" className="block text-sm text-gray-600 hover:text-[#2d5a8c] transition-colors cursor-pointer leading-snug">
                      Escritura y señalización
                    </a>
                    <a href="#section-11" className="block text-sm text-gray-600 hover:text-[#2d5a8c] transition-colors cursor-pointer leading-snug">
                      Suministros complementarios
                    </a>
                  </nav>
                </div>
                
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
                  <h4 className="text-sm font-bold text-[#1e3a5f] mb-4 uppercase tracking-wider">Compartir</h4>
                  <div className="flex gap-3">
                    <a
                      href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcydezh.readdy.co%2Fblog%2Finsumos-oficina-empresa-mediana"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-gray-500 hover:text-[#2d5a8c] hover:shadow-md transition-all cursor-pointer border border-gray-200"
                    >
                      <i className="ri-facebook-fill text-lg"></i>
                    </a>
                    <a
                      href="https://wa.me/?text=Qu%C3%A9%20insumos%20de%20oficina%20no%20deben%20faltar%20en%20una%20empresa%20mediana%20https%3A%2F%2Fcydezh.readdy.co%2Fblog%2Finsumos-oficina-empresa-mediana"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-gray-500 hover:text-green-600 hover:shadow-md transition-all cursor-pointer border border-gray-200"
                    >
                      <i className="ri-whatsapp-line text-lg"></i>
                    </a>
                    <button className="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-gray-500 hover:text-[#2d5a8c] hover:shadow-md transition-all cursor-pointer border border-gray-200">
                      <i className="ri-link text-lg"></i>
                    </button>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>
      
      {/* Navegación entre artículos */}
      <section className="border-t border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-10">
          <div className="grid grid-cols-2 gap-6">
            <Link
              to="/blog/como-optimizar-compras-papeleria-empresa"
              className="group flex items-center gap-4 p-5 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer border border-gray-100"
            >
              <i className="ri-arrow-left-line text-xl text-gray-400 group-hover:text-[#2d5a8c] transition-colors"></i>
              <div className="min-w-0">
                <span className="text-xs text-gray-400 font-medium uppercase tracking-wider">Anterior</span>
                <p className="text-sm font-semibold text-gray-700 group-hover:text-[#2d5a8c] transition-colors truncate mt-1">
                  Cómo optimizar las compras de papelería en tu empresa
                </p>
              </div>
            </Link>
            <Link
              to="/blog/ventajas-proveedor-b2b-insumos-puebla"
              className="group flex items-center justify-end gap-4 p-5 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer text-right border border-gray-100"
            >
              <div className="min-w-0">
                <span className="text-xs text-gray-400 font-medium uppercase tracking-wider">Siguiente</span>
                <p className="text-sm font-semibold text-gray-700 group-hover:text-[#2d5a8c] transition-colors truncate mt-1">
                  Ventajas de contratar un proveedor B2B de insumos empresariales en Puebla
                </p>
              </div>
              <i className="ri-arrow-right-line text-xl text-gray-400 group-hover:text-[#2d5a8c] transition-colors"></i>
            </Link>
          </div>
        </div>
      </section>
      
      {/* Artículos Relacionados */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1e3a5f] mb-10 text-center">
            Otros artículos que te pueden interesar
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Link
              to="/blog/donde-comprar-articulos-oficina-puebla"
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-gray-100 group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="¿Dónde comprar artículos de oficina en Puebla para empresas?"
                  title="¿Dónde comprar artículos de oficina en Puebla para empresas?"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  src="https://public.readdy.ai/ai/img_res/5866ae6e74265da094ba5953c35eaa39.jpg"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-[#2d5a8c] text-white px-3 py-1 rounded-full text-xs font-bold">Guía de Compra</span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-gray-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    15 Marzo 2024
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    5 min
                  </span>
                </div>
                <h3 className="text-base font-bold text-[#1e3a5f] group-hover:text-[#2d5a8c] transition-colors leading-snug line-clamp-2">
                  ¿Dónde comprar artículos de oficina en Puebla para empresas?
                </h3>
              </div>
            </Link>
            
            <Link
              to="/blog/como-optimizar-compras-papeleria-empresa"
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-gray-100 group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Cómo optimizar las compras de papelería en tu empresa"
                  title="Cómo optimizar las compras de papelería en tu empresa"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  src="https://readdy.ai/api/search-image?query=business%20professional%20organizing%20office%20supplies%20inventory%20management%20stationery%20products%20organized%20desk%20with%20paper%20folders%20pens%20corporate%20purchasing%20planning%20charts%20efficient%20workspace%20clean%20modern%20office&width=800&height=500&seq=blog-cx-puebla-02&orientation=landscape"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-[#2d5a8c] text-white px-3 py-1 rounded-full text-xs font-bold">Gestión Empresarial</span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-gray-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    10 Marzo 2024
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    6 min
                  </span>
                </div>
                <h3 className="text-base font-bold text-[#1e3a5f] group-hover:text-[#2d5a8c] transition-colors leading-snug line-clamp-2">
                  Cómo optimizar las compras de papelería en tu empresa
                </h3>
              </div>
            </Link>
            
            <Link
              to="/blog/ventajas-proveedor-b2b-insumos-puebla"
              className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-gray-100 group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  alt="Ventajas de contratar un proveedor B2B de insumos empresariales en Puebla"
                  title="Ventajas de contratar un proveedor B2B de insumos empresariales en Puebla"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  src="https://readdy.ai/api/search-image?query=business%20to%20business%20B2B%20partnership%20handshake%20professional%20meeting%20office%20supplies%20delivery%20truck%20corporate%20clients%20business%20relationship%20modern%20office%20environment%20professional%20service%20team&width=800&height=500&seq=blog-cx-puebla-04&orientation=landscape"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-[#2d5a8c] text-white px-3 py-1 rounded-full text-xs font-bold">Modelo de Negocio</span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-gray-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    28 Febrero 2024
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    6 min
                  </span>
                </div>
                <h3 className="text-base font-bold text-[#1e3a5f] group-hover:text-[#2d5a8c] transition-colors leading-snug line-clamp-2">
                  Ventajas de contratar un proveedor B2B de insumos empresariales en Puebla
                </h3>
              </div>
            </Link>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default BlogPost3;